export default __webpack_public_path__ + "static/media/compu1-1.15cf1a4e.jpg";